import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c543cd98&scoped=true&lang=html&"
import script from "./aggregation.js?vue&type=script&lang=js&"
export * from "./aggregation.js?vue&type=script&lang=js&"
import style0 from "./aggregation.styl?vue&type=style&index=0&id=c543cd98&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c543cd98",
  null
  
)

export default component.exports